// extracted by mini-css-extract-plugin
export default {"ContactImg":"Contact_ContactImg__a2M4x"};